import "./repo.3667f1b3.js";


      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire8d3d"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire8d3d"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRequire("2QScX");

var $acw62 = parcelRequire("acw62");

var $aRPiL = parcelRequire("aRPiL");

var $kjfd6 = parcelRequire("kjfd6");
// Hydrate links stashed in data-href to dodge Parcel's build-time URL resolver
// (same pattern as map iframe data-src below).
document.querySelectorAll("a[data-href]").forEach((a)=>{
    a.href = a.dataset.href;
});
const $2b6e161c9edcf319$var$mount = document.querySelector('[data-embed="officer"]');
if ($2b6e161c9edcf319$var$mount) {
    $2b6e161c9edcf319$var$mount.style.minHeight = "auto";
    $2b6e161c9edcf319$var$mount.style.border = "none";
    (0, $aRPiL.createRoot)($2b6e161c9edcf319$var$mount).render(/*#__PURE__*/ (0, $acw62.createElement)((0, $kjfd6.default)));
}
// ── Map switcher ──
(function() {
    const select = document.getElementById("map-metric");
    const geoBtns = document.querySelectorAll(".map-geo-btn");
    const stopBtns = document.querySelectorAll(".map-stop-btn");
    const stopToggle = document.getElementById("map-stop-toggle");
    const geoToggle = document.querySelector(".map-geo-toggle");
    const frames = document.querySelectorAll(".map-frame");
    // Which dimensions each metric supports. A metric with `geo: false` ignores
    // the neighborhood/block toggle; `stop: false` ignores the stop-type toggle.
    // The point map ("points") is a single frame with no aggregation dimensions.
    const METRIC_DIMS = {
        disparity: {
            geo: true,
            stop: true
        },
        count: {
            geo: true,
            stop: true
        },
        rate: {
            geo: true,
            stop: true
        },
        "pop-black": {
            geo: true,
            stop: false
        },
        "pop-white": {
            geo: true,
            stop: false
        },
        points: {
            geo: false,
            stop: false
        }
    };
    // Hydrate any iframe whose src was stashed in data-src to dodge Parcel's
    // build-time URL resolver. loading="lazy" on the iframe + the .map-frame's
    // default display:none keep the inner document from actually fetching until
    // the user switches to that map.
    document.querySelectorAll(".map-frame iframe[data-src]").forEach((iframe)=>{
        iframe.src = iframe.dataset.src;
    });
    // Default metric is driven by the <select> in markup (the selected option).
    let activeMetric = select ? select.value : "disparity";
    let activeGeo = "neighborhood";
    let activeStop = "all";
    // The point map ("points") has no pre-rendered stop frames — instead the stop
    // buttons drive the live MapLibre filter *inside* the iframe, via postMessage.
    // So `points` keeps {stop:false} for frame selection (one frame), but the stop
    // toggle is still enabled and routed to the iframe. Maps each parent button to
    // the viewer's stop_type vocabulary (vehicle/pedestrian/other).
    const POINTS = "points";
    const POINTS_STOP_TYPES = {
        "all": [
            "vehicle",
            "pedestrian",
            "other"
        ],
        "pedestrian": [
            "pedestrian"
        ],
        "motor-vehicle": [
            "vehicle"
        ]
    };
    function pointsFrameIframe() {
        return document.querySelector('.map-frame[data-metric="points"] iframe');
    }
    // Push the active stop selection into the embedded viewer. Best-effort: if the
    // viewer isn't ready yet, it re-requests via a "ready" message (handled below).
    function sendStopFilterToIframe() {
        const iframe = pointsFrameIframe();
        const values = POINTS_STOP_TYPES[activeStop] || POINTS_STOP_TYPES.all;
        iframe?.contentWindow?.postMessage({
            source: "contact-cards-embed",
            action: "set-stop-types",
            values: values
        }, location.origin);
    }
    function dimsFor(metric) {
        return METRIC_DIMS[metric] || {
            geo: true,
            stop: true
        };
    }
    function showMap() {
        frames.forEach((f)=>f.classList.remove("is-active"));
        const dims = dimsFor(activeMetric);
        let sel = `.map-frame[data-metric="${activeMetric}"]`;
        if (dims.geo) sel += `[data-geo="${activeGeo}"]`;
        if (dims.stop) sel += `[data-stop="${activeStop}"]`;
        const target = document.querySelector(sel);
        if (target) target.classList.add("is-active");
    }
    function updateToggles() {
        const dims = dimsFor(activeMetric);
        // points enables the stop toggle even though it has no stop *frame* — the
        // buttons drive the embedded map's filter rather than swapping frames.
        const stopOn = dims.stop || activeMetric === POINTS;
        if (stopToggle) {
            stopToggle.classList.toggle("is-disabled", !stopOn);
            stopBtns.forEach((b)=>b.disabled = !stopOn);
        }
        if (geoToggle) {
            geoToggle.classList.toggle("is-disabled", !dims.geo);
            geoBtns.forEach((b)=>b.disabled = !dims.geo);
        }
    }
    if (select) select.addEventListener("change", function() {
        activeMetric = this.value;
        updateToggles();
        showMap();
        // landing on points: sync the embedded map to the active stop button
        if (activeMetric === POINTS) sendStopFilterToIframe();
    });
    geoBtns.forEach((btn)=>{
        btn.addEventListener("click", function() {
            if (this.disabled) return;
            activeGeo = this.dataset.geo;
            geoBtns.forEach((b)=>{
                b.classList.remove("is-active");
                b.setAttribute("aria-pressed", "false");
            });
            this.classList.add("is-active");
            this.setAttribute("aria-pressed", "true");
            showMap();
        });
    });
    stopBtns.forEach((btn)=>{
        btn.addEventListener("click", function() {
            if (this.disabled) return;
            activeStop = this.dataset.stop;
            stopBtns.forEach((b)=>{
                b.classList.remove("is-active");
                b.setAttribute("aria-pressed", "false");
            });
            this.classList.add("is-active");
            this.setAttribute("aria-pressed", "true");
            showMap();
            // on points, the buttons filter the live embedded map instead of swapping frames
            if (activeMetric === POINTS) sendStopFilterToIframe();
        });
    });
    // The embedded viewer announces "ready" once its map has loaded; (re)push the
    // current stop selection then, in case the user picked it before load finished.
    window.addEventListener("message", (e)=>{
        if (e.origin !== location.origin) return;
        const d = e.data;
        if (d && d.source === "cpd-stops-viewer" && d.action === "ready") {
            if (activeMetric === POINTS) sendStopFilterToIframe();
        }
    });
    // Apply the initial metric (set via the selected <option>) on load: sync the
    // toggle enabled/disabled state and visible frame to it, and — when the default
    // is the point map — push the active stop filter into the embedded viewer.
    updateToggles();
    showMap();
    if (activeMetric === POINTS) sendStopFilterToIframe();
})();
document.querySelectorAll(".demand-continue-btn").forEach((btn)=>{
    const panel = document.getElementById(btn.getAttribute("aria-controls"));
    const expand = btn.closest(".demand-expand");
    if (!panel || !expand) return;
    btn.addEventListener("click", ()=>{
        if (btn.getAttribute("aria-expanded") === "true") return;
        btn.setAttribute("aria-expanded", "true");
        panel.hidden = false;
        expand.classList.add("is-expanded");
        btn.remove();
    });
});


//# sourceMappingURL=repo.4f17335d.js.map
